import { Operation } from "@/backend/models/operation";
import { useGetParametersToAssignFromInput } from "@/frontend/hooks/parameters";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";
import { DataTypes } from "@/types/itemReferenceTypes";
import { operationTypes } from "@/types/operationTypes";
import { ParameterInputType, SelectableParameter } from "@/types/parameterTypes";
import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { GenericParameterSelect } from "./GenericParameterSelect";
import { CreateOperationReply } from "@/backend/express/controllers/operationController";
import { Container } from "@/backend/models/containers/container";
import { PARENT_TYPES } from "@/types/containerTypes";


export function TableAddModal(props: {
  scenario: Container,
  onCreate: () => Promise<CreateOperationReply>,
  setShow: (show: boolean) => void
}) {
  const { scenario, onCreate, setShow } = props;
  const [linkedOutput, setLinkedOutput] = useState<SelectableParameter | undefined>(undefined);
  const operation = new Operation({
    id: '',
    type: operationTypes.FieldInput,
    parentId: scenario.id,
    position: 0,
    rootId: scenario.rootId,
    rootType: scenario.rootType,
    parentType: PARENT_TYPES.CONTAINER,
    isScaffold: scenario.isScaffold,
  });
  const parameters = useGetParametersToAssignFromInput(operation, scenario.parentId)
    .filter(param => (param.inputType === ParameterInputType.TABLE || param.inputType === ParameterInputType.LIST) && param.fieldType === CUSTOM_FIELD_TYPES.Object);

  const handleSave = async () => {
    const response = await onCreate();
    if (response.parameters && response.parameters.length > 0 && linkedOutput) {
      const reference = {
        dataConsumerId: response.parameters[0].id,
        dataConsumerType: DataTypes.Parameter,
        dataSourceId: linkedOutput.id,
        dataSourceType: DataTypes.Parameter,
      };
      await useParameterStore.getState().createReference(reference);
    }
    handleClose();
  };

  const handleClose = () => {
    setShow(false);
    setLinkedOutput(undefined);
  };

  return (
    <Modal size="sm" show onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.get('createTable')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='my-3'>
          <Form.Label>{I18n.get('assignValueFrom')}</Form.Label>
          <GenericParameterSelect
            parameters={parameters}
            currentParameter={linkedOutput}
            createReference={(param) => setLinkedOutput(param)}
            deleteReference={() => setLinkedOutput(undefined)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{I18n.get('cancel')}</Button>
        <Button type="submit" variant="primary" onClick={() => void handleSave()}>{I18n.get('confirm')}</Button>
      </Modal.Footer>
    </Modal>
  );
}
